module.exports = __webpack_public_path__ + "static/storck-logo-ce15066973ac7c3aa25c57c9e8a69b81.jpeg";